<app-top-nav></app-top-nav>

<div class="container">
  <div class="main-content">
    <div class="employee-header">
      <div class="employee-id">Employees | #3919364</div>
      <div class="employee-name">Name</div>
    </div>

    <div class="profile-summary">
      <div class="profile-info">
        <img
          src="https://randomuser.me/api/portraits/men/1.jpg"
          alt="profile"
          class="profile-pic"
        />
        <div>
          <div class="profile-name">Inés Néstor</div>
          <div class="profile-title">Test Engineer</div>
        </div>
      </div>
      <div>
        <button class="review-btn" (click)="navigateToReview()">Review</button>
        <button class="propose-btn" (click)="openProposalModal()">
          Propose candidate
        </button>
      </div>
    </div>

    <div class="review-dates">
      <div>Reviewer <span class="bold">Avery Elizabeth</span></div>
      <div>Review Period <span class="bold">12/12/2024</span></div>
      <div>Self-Review Submitted on <span class="bold">12/12/2024</span></div>
      <div>Review Due <span class="bold">12/12/2024</span></div>
      <div>Finalize Due <span class="bold">12/12/2024</span></div>
    </div>

    <div class="performance-review">
      <div class="review-title-row">
        <div class="review-title">Q3 Performance Review</div>
        <div class="last-modified">
          <span class="bold">Last modification 12/12/2024</span>
        </div>
      </div>
      <div class="review-desc">
        Pizza ipsum dolor meat lovers buffalo. Lasagna Chicago bell personal
        pizza steak mayo pork pepperoni. Style peppers Chicago ranch party
        cheese large NY ranch pineapple. Pineapple bbq NY peppers deep dolor
        tomato string. Sautéed white broccoli Aussie hand ham pineapple platter
        garlic. Broccoli tomato.
      </div>
      <div class="review-cards">
        <div class="card">
          <div class="card-title">Niche Skill</div>
          <div class="chips">
            <span class="chip leader">Leader</span>
            <span class="chip design">Design</span>
            <span class="chip html">HTML</span>
            <span class="chip java">Java</span>
            <span class="chip angular">Angular</span>
          </div>
          <div class="card-subtitle">Niche Skill Description</div>
          <div class="card-desc">
            Pizza dolor meat lovers buffalo. Melted Chicago fresh pineapple ham
            style sauce ranch wing rib. Dolor pork wing.
          </div>
          <a
            class="read-more"
            (click)="navigateToReview()"
            style="cursor: pointer"
            >Read More</a
          >
        </div>
        <div class="card">
          <div class="card-title">
            Development Actions
            <span class="card-sub-detail"
              >(Experience, Exposure & Education)</span
            >
          </div>
          <div class="card-desc">
            Pizza ipsum dolor meat lovers buffalo. Melted Chicago fresh
            pineapple ham style sauce ranch wing rib. Dolor pork wing.
          </div>
          <a
            class="read-more"
            (click)="navigateToReview()"
            style="cursor: pointer"
            >Read More</a
          >
        </div>
        <div class="card">
          <div class="card-title">Employee Aspirations</div>
          <div class="card-desc">
            Pizza ipsum dolor meat lovers buffalo. Melted Chicago fresh
            pineapple ham style sauce ranch wing rib. Dolor pork wing.
          </div>
          <a class="read-more" href="#">Read More</a>
        </div>
        <div class="card">
          <div class="card-title">
            Employee with Possible Exceptional Contribution
          </div>
          <div class="card-desc">
            Pizza ipsum dolor meat lovers buffalo. Melted Chicago fresh
            pineapple ham style sauce ranch wing rib. Dolor pork wing.
          </div>
          <a class="read-more" href="#">Read More</a>
        </div>
        <div class="card">
          <div class="card-title">Early Talent</div>
          <div class="card-desc">
            Pizza ipsum dolor meat lovers buffalo. Mouth beef fresh black
            tomatoes. Tomatoes pan chicken tomato rib party meatball party.
            Buffalo burnt pizza marinara steak tossed ricotta NY.
          </div>
          <a class="read-more" href="#">Read More</a>
        </div>
        <div class="card">
          <div class="card-title">Employee Key Strengths</div>
          <div class="chips">
            <span class="chip leader">Leader</span>
            <span class="chip design">Design</span>
            <span class="chip html">HTML</span>
          </div>
        </div>
        <div class="card">
          <div class="card-title">Retention Risk</div>
          <div class="retention-risk-bars">
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar highlight"></div>
            <div class="bar"></div>
            <div class="bar"></div>
          </div>
        </div>
      </div>

      <div class="comments-section">
        <div class="card-title">Comments</div>
        <div class="card-desc">
          Pizza ipsum dolor meat lovers buffalo. Wing pork ranch burnt chicken
          personal Aussie garlic garlic tossed. Burnt tomatoes mozzarella pizza
          sausage pizza white. Garlic tomato mushrooms ricotta peppers. Steak
          lovers pepperoni thin mozzarella tomato NY. Rib ham ham garlic rib
          melted banana olives bbq tomato. Tomatoes pizza hand green pork.
          Tomatoes.
        </div>
        <a class="read-more" href="#">Read More</a>
      </div>
    </div>
  </div>
</div>

<!-- Proposal Modal -->
<app-proposal-modal
  [isOpen]="isProposalModalOpen"
  [candidateName]="candidateName"
  (close)="closeProposalModal()"
  (submit)="onProposalSubmit($event)"
></app-proposal-modal>
